import AppFooter from '../components/ui/AppFooter';
import AppHeader from '../components/ui/AppHeader';

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <div style={{ flex: 1 }}>
        <div
          style={{
            maxWidth: '900px',
            margin: '3rem auto',
            padding: '0 2rem',
            textAlign: 'center',
          }}
        >
          <img
            src="/images/404.png"
            alt="404 - Seite nicht gefunden"
            style={{ width: '100%', maxWidth: '1280px', height: 'auto', marginBottom: '2rem' }}
          />
          <h1 className="h1" style={{ marginBottom: '1rem' }}>
            Diese Seite gibt es nicht.
          </h1>
          <p className="p" style={{ marginBottom: '2rem', color: '#4a4a4a' }}>
            Die von Ihnen aufgerufene Seite wurde nicht gefunden. Möglicherweise
            wurde der Link falsch eingegeben oder die Seite existiert nicht mehr.
          </p>
          <a href="/" className="hero-btn hero-btn-primary" style={{ textDecoration: 'none', display: 'inline-block' }}>
            Zurück zur Startseite
          </a>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
